import KitForm from "./KitForm";

export default function ArticleFooterCTA({ testId = "article" }) {
  return (
    <section
      data-testid={`${testId}-footer-cta`}
      className="mt-24 md:mt-32 bg-card-surface border border-subtle rounded-[2rem] p-8 md:p-16 text-center flex flex-col items-center"
    >
      <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-tertiary">
        The Lab · Private dispatch
      </span>
      <h2 className="mt-5 font-display text-primary text-3xl md:text-5xl font-light tracking-tight leading-[1.05] max-w-2xl">
        The Solo Studio Blueprint
      </h2>
      <p className="mt-5 max-w-xl text-secondary text-base md:text-lg leading-relaxed">
        Enter your email to get the 2026 Solo Studio Blueprint delivered instantly, plus my weekly dispatch on visual automation and the AI stack.
      </p>
      <div className="mt-10 w-full max-w-xl">
        <KitForm testId={`${testId}-footer-kit-form`} />
      </div>
    </section>
  );
}
